import { render, staticRenderFns } from "./filterText.vue?vue&type=template&id=888a5ee2"
import script from "./filterText.vue?vue&type=script&setup=true&lang=js"
export * from "./filterText.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports